import classNames from 'classnames'
import { RenderWhen } from 'legacy/lut/components/shared/renderWnen/RenderWhen'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Tooltip } from 'core-components/library/tooltip'

import styles from './Label.module.scss'

interface ILabelProps {
  translation: string
  validationMessage: string
  isEmptyValue: boolean
}

export const Label = ({ translation, validationMessage, isEmptyValue }: ILabelProps) => {
  return (
    <div className={styles.text}>
      <Translation text={translation} />

      <RenderWhen condition={Boolean(validationMessage || isEmptyValue)}>
        <Tooltip
          tipContent={() => (
            <Translation span text={validationMessage || 'Field must not be empty'} />
          )}
        >
          <i className={classNames('kbase kbase-warning', styles.dangerIcon)} />
        </Tooltip>
      </RenderWhen>
    </div>
  )
}
